import { render } from "./SupplierDetails.vue?vue&type=template&id=3872dbab&scoped=true"
import script from "./SupplierDetails.vue?vue&type=script&lang=js"
export * from "./SupplierDetails.vue?vue&type=script&lang=js"

import "./SupplierDetails.vue?vue&type=style&index=0&id=3872dbab&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3872dbab"]])

export default __exports__